import { Link } from 'react-router-dom';
import { useVehicles } from '../../../hooks/useVehicles';
import VehicleCard from '../../inventory/components/VehicleCard';
import { VehicleCardSkeleton } from '../../../components/base/SkeletonCard';

export default function AstoriaInventory() {
  const { vehicles, loading } = useVehicles();
  
  const availableVehicles = vehicles
    .filter(v => v.status === 'available')
    .slice(0, 12);

  return (
    <section className="py-16 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-bold text-gray-900 mb-4">
            Used Cars Available Near Astoria
          </h2>
          <p className="text-lg text-gray-600 max-w-3xl mx-auto">
            All vehicles are in stock at our Warrenton location and available for free delivery to Astoria. 
            What you see is what you get — no bait and switch.
          </p>
        </div>

        {loading ? (
          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
            {[...Array(6)].map((_, i) => (
              <VehicleCardSkeleton key={i} />
            ))}
          </div>
        ) : availableVehicles.length > 0 ? (
          <>
            <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6 mb-10">
              {availableVehicles.map((vehicle, index) => (
                <VehicleCard key={vehicle.id} vehicle={vehicle} priority={index === 0} />
              ))}
            </div>
            <div className="text-center">
              <Link
                to="/inventory"
                className="inline-flex items-center gap-2 bg-teal-600 text-white px-8 py-4 rounded-lg font-semibold text-lg hover:bg-teal-700 transition whitespace-nowrap shadow-lg"
              >
                View All Available Vehicles
                <i className="ri-arrow-right-line"></i>
              </Link>
            </div>
          </>
        ) : (
          <div className="text-center py-12 bg-white rounded-lg border border-gray-200">
            <i className="ri-car-line text-6xl text-gray-300 mb-4"></i>
            <p className="text-gray-600 text-lg mb-4">No vehicles currently available. Check back soon!</p>
            <Link to="/inventory" className="text-teal-600 hover:text-teal-700 font-semibold">
              View All Inventory
            </Link>
          </div>
        )}
      </div>
    </section>
  );
}